export default __webpack_public_path__ + "static/media/mas-salagros.1a99234a.jpg";